<div class="connection-language">
  <language />
</div>
<div style="width: 100%; height: 100%; display: flex">
  <!-- PICTURE -->
  @if (!$isMobile()) {
    <div class="background-picture"></div>
  }
  <div class="connection-container">
    <div class="form-alert-container">
      <!-- FORM -->
      <div class="form-card">
        <div class="connection-logo" [routerLink]="['/login']" alt="Logo Coyote Fleet Connect"></div>

        <div class="container-header">
          <p class="title">{{ 'CONNECTION.FORGETPASSWORD' | translate }} ?</p>
          @if (isResetPassword) {
            <p class="subtitle">{{ 'CONNECTION.INFORMPASSWORD' | translate }}</p>
          } @else {
            <p class="subtitle">
              {{ 'CONNECTION.' + (isExpiredToken ? 'TOKENEXPIRED' : 'INFORMMAIL') | translate }}
            </p>
          }
        </div>

        <div class="form-container">
          @if (isResetPassword) {
            <!-- FORM -->
            <form [formGroup]="passwordForm" style="display: flex; flex-direction: column; gap: 0.5rem">
              <!-- NEW PASSWORD -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'CONNECTION.NEWPASSWORD' | translate }}</mat-label>
                <input
                  matInput
                  [type]="hide ? 'password' : 'text'"
                  formControlName="password"
                  autocomplete="new-password" />
                <mat-icon matSuffix (click)="hide = !hide">
                  {{ hide ? 'visibility_off' : 'visibility' }}
                </mat-icon>
                <mat-hint align="end">{{ password?.value?.length || 0 }}/50</mat-hint>
                @if (password?.invalid && (password?.dirty || password?.touched)) {
                  <mat-error>
                    @if (password?.hasError('minlength')) {
                      <span>{{ 'CONNECTION.PASSWORDMIN' | translate }}</span>
                    }
                    @if (password?.hasError('maxlength')) {
                      <span>{{ 'CONNECTION.PASSWORDMAX' | translate }}</span>
                    }
                  </mat-error>
                }
              </mat-form-field>

              <!-- CONFIRM NEW PASSWORD -->
              <mat-form-field appearance="outline" color="accent">
                <mat-label>{{ 'CONNECTION.CONFIRMNEWPASSWORD' | translate }}</mat-label>
                <input
                  matInput
                  [type]="hideConfirm ? 'password' : 'text'"
                  formControlName="passwordConfirm"
                  autocomplete="new-password-confirm" />
                <mat-icon matSuffix (click)="hideConfirm = !hideConfirm">
                  {{ hideConfirm ? 'visibility_off' : 'visibility' }}
                </mat-icon>
                <mat-hint align="end">{{ passwordConfirm?.value?.length || 0 }}/50</mat-hint>
                @if (passwordConfirm?.invalid && (passwordConfirm?.dirty || passwordConfirm?.touched)) {
                  <mat-error>
                    @if (passwordConfirm?.hasError('minlength')) {
                      <span>{{ 'CONNECTION.PASSWORDMIN' | translate }}</span>
                    }
                    @if (passwordConfirm?.hasError('maxlength')) {
                      <span>{{ 'CONNECTION.PASSWORDMAX' | translate }}</span>
                    }
                  </mat-error>
                }
              </mat-form-field>

              <!-- FORM errors -->
              @if (passwordForm.hasError('passInvalid') && (password?.dirty || password?.touched)) {
                <mat-error>
                  <span class="error">{{ 'USER.INVALIDPASSWORD' | translate }}</span>
                </mat-error>
              }
              @if (
                passwordForm.hasError('passError') && (passwordConfirm?.dirty || passwordConfirm?.touched)
              ) {
                <mat-error>
                  <span class="error">{{ 'CONNECTION.SAMEPASSWORD' | translate }}</span>
                </mat-error>
              }
            </form>
          } @else {
            <mat-form-field appearance="outline">
              <mat-label>{{ 'COMMON.MAIL' | translate }}</mat-label>
              <input matInput type="mail" [formControl]="email" />
            </mat-form-field>
            @if (email.invalid && (email.dirty || email.touched)) {
              <mat-error>
                {{ 'CONNECTION.INVALIDMAIL' | translate }}
              </mat-error>
            }
          }
        </div>
        @if (isResetPassword) {
          @if (
            !resultOnResetPassword ||
            resultOnResetPassword === 'SUCCESS_PASSWORD' ||
            resultOnResetPassword === 'INVALID_PASSWORD'
          ) {
            <button
              type="submit"
              matButton="filled"
              color="accent"
              class="stretch"
              (click)="reset()"
              (keyup.enter)="reset()"
              [disabled]="passwordForm.invalid || isDisplayLoader">
              {{ 'COMMON.RESET' | translate }}
            </button>
          }
        } @else {
          <button
            type="submit"
            matButton="filled"
            color="accent"
            class="stretch"
            (click)="send()"
            (keyup.enter)="send()"
            [disabled]="email.invalid || isDisplayLoader || resultOnSendMail">
            {{ 'COMMON.SEND' | translate }}
          </button>
        }
      </div>
      @if (!isResetPassword && !resultOnSendMail) {
        <alert genre="muted" variant="info">
          {{ 'CONNECTION.INSTRUCTIONMAIL' | translate }}
        </alert>
      } @else {
        @if (
          (isResetPassword && resultOnResetPassword && dictionnaryErrors[resultOnResetPassword]) ||
          (!isResetPassword && resultOnSendMail && dictionnaryErrors[resultOnSendMail])
        ) {
          <alert
            genre="muted"
            [variant]="
              resultOnResetPassword === 'SUCCESS_PASSWORD' || resultOnSendMail === 'SUCCESS'
                ? 'success'
                : 'warn'
            ">
            {{ 'CONNECTION.' + (isResetPassword ? resultOnResetPassword : resultOnSendMail) | translate }}
          </alert>
        }
      }
    </div>
  </div>
</div>
